/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { ArgumentTypes, FunctionPlugin } from './FunctionPlugin';
export class SimpleArithmerticPlugin extends FunctionPlugin {
    add(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.ADD'), this.interpreter.arithmeticHelper.addWithEpsilon);
    }
    concat(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.CONCAT'), this.interpreter.arithmeticHelper.concat);
    }
    divide(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.DIVIDE'), this.interpreter.arithmeticHelper.divide);
    }
    eq(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.EQ'), this.interpreter.arithmeticHelper.eq);
    }
    gt(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.GT'), this.interpreter.arithmeticHelper.gt);
    }
    gte(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.GTE'), this.interpreter.arithmeticHelper.geq);
    }
    lt(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.LT'), this.interpreter.arithmeticHelper.lt);
    }
    lte(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.LTE'), this.interpreter.arithmeticHelper.leq);
    }
    minus(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.MINUS'), this.interpreter.arithmeticHelper.subtract);
    }
    multiply(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.MULTIPLY'), this.interpreter.arithmeticHelper.multiply);
    }
    ne(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.NE'), this.interpreter.arithmeticHelper.neq);
    }
    pow(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.POW'), this.interpreter.arithmeticHelper.pow);
    }
    uminus(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.UMINUS'), this.interpreter.arithmeticHelper.unaryMinus);
    }
    upercent(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.UNARY_PERCENT'), this.interpreter.arithmeticHelper.unaryPercent);
    }
    uplus(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('HF.UPLUS'), this.interpreter.arithmeticHelper.unaryPlus);
    }
}
SimpleArithmerticPlugin.implementedFunctions = {
    'HF.ADD': {
        method: 'add',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
        ],
    },
    'HF.CONCAT': {
        method: 'concat',
        parameters: [
            { argumentType: ArgumentTypes.STRING, passSubtype: true },
            { argumentType: ArgumentTypes.STRING, passSubtype: true },
        ],
    },
    'HF.DIVIDE': {
        method: 'divide',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
        ],
    },
    'HF.EQ': {
        method: 'eq',
        parameters: [
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
        ]
    },
    'HF.GT': {
        method: 'gt',
        parameters: [
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
        ]
    },
    'HF.GTE': {
        method: 'gte',
        parameters: [
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
        ]
    },
    'HF.LT': {
        method: 'lt',
        parameters: [
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
        ]
    },
    'HF.LTE': {
        method: 'lte',
        parameters: [
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
        ]
    },
    'HF.MINUS': {
        method: 'minus',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
        ],
    },
    'HF.MULTIPLY': {
        method: 'multiply',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
        ],
    },
    'HF.NE': {
        method: 'ne',
        parameters: [
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
            { argumentType: ArgumentTypes.NOERROR, passSubtype: true },
        ]
    },
    'HF.POW': {
        method: 'pow',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
        ],
    },
    'HF.UMINUS': {
        method: 'uminus',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
        ],
    },
    'HF.UNARY_PERCENT': {
        method: 'upercent',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
        ],
    },
    'HF.UPLUS': {
        method: 'uplus',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER, passSubtype: true },
        ],
    },
};
